// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"169":"0908de52","279":"33523d29","335":"b3943edc","336":"bdf08113","389":"654e65f6","394":"2b4d2828","559":"462c6a6c","692":"dd49b9d8","725":"a48667b7","752":"e99b9b2b","760":"367c2812"}[chunkId] + ".js";
};